function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTrust2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M119.49 120.81V61.7a6.11 6.11 0 0 1 5.11-6.03l19.25-3.21a264.657 264.657 0 0 0 94.65-35.31l14.31-8.75c1.96-1.2 4.42-1.2 6.38 0l14.31 8.75a264.56 264.56 0 0 0 35.17 18.05M341.76 46.66h.01c8.67 2.38 17.47 4.32 26.38 5.8l19.25 3.21a6.11 6.11 0 0 1 5.11 6.03v113.42c0 12.15-1.27 24.12-3.74 35.76M119.49 155.81v19.03c0 10.89 1.02 21.64 3.01 32.13",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#627384",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.243 221.591c-5.179-14.776-7.918-30.541-7.918-46.749v-91l14.101-3.164a295.457 295.457 0 0 0 81.637-31.611L256 43.975l8.937 5.092a295.402 295.402 0 0 0 81.636 31.611l14.101 3.164v91.274c0 14.77-2.278 29.177-6.606 42.805",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#627384",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.6 227.477a15.044 15.044 0 0 1-10.439-4.212l-43.133-41.568c-5.982-5.765-6.159-15.289-.393-21.271 5.765-5.982 15.289-6.158 21.272-.393l31.461 30.32 51.127-61.644c5.306-6.396 14.788-7.279 21.184-1.976 6.395 5.304 7.279 14.788 1.975 21.183l-61.474 74.12a15.045 15.045 0 0 1-11.58 5.441zM121.182 389.749l9.791-9.791c7.532-7.532 19.743-7.532 27.275 0h0c7.532 7.532 7.532 19.743 0 27.275l-9.791 9.791c-7.532 7.532-19.744 7.532-27.275 0h0c-7.532-7.531-7.532-19.743 0-27.275zM278.367 471.478c6.752 6.752 6.752 17.7 0 24.453h0c-6.752 6.752-17.7 6.752-24.453 0l-8.752-8.752",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#627384",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.944 452.162c7.579 7.579 7.579 19.868 0 27.447h0c-7.579 7.579-19.868 7.579-27.447 0l-14.678-14.678M322.583 405.907l22.39 22.39c7.579 7.579 7.579 19.868 0 27.447h0c-7.579 7.579-19.868 7.579-27.447 0l-22.39-22.39",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#627384",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.833 377.481 20.005 19.787c7.579 7.579 7.579 19.868 0 27.447h0c-7.579 7.579-19.868 7.579-27.447 0M186.803 249.094l49.597 12.984M203.009 471.576l13.018-13.018c7.532-7.532 19.744-7.532 27.275 0h0c7.532 7.532 7.532 19.744 0 27.275l-13.018 13.018c-7.532 7.532-19.743 7.532-27.275 0h0c-7.532-7.532-7.532-19.743 0-27.275z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#627384",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.009 471.576c-7.532 7.532-19.744 7.532-27.275 0h0c-7.532-7.532-7.532-19.744 0-27.275l19.329-19.329c7.532-7.532 19.744-7.532 27.275 0h0c7.532 7.532 7.532 19.744 0 27.275l-6.31 6.31M175.733 444.3c-7.532 7.532-19.744 7.532-27.275 0h0c-7.532-7.532-7.532-19.743 0-27.275M158.249 407.234l7.475-7.475c7.532-7.532 19.743-7.532 27.275 0h0c7.532 7.532 7.532 19.744 0 27.275M329.694 246.432l-11.805 3.744a43.12 43.12 0 0 1-10.008 1.91l-49.339 3.457a44.705 44.705 0 0 0-29.652 14.195l-28.105 30.302a33.923 33.923 0 0 0-9.052 23.07v42.687a6.88 6.88 0 0 0 6.894 6.88h0c17.224-.034 31.183-13.98 31.234-31.203l.019-6.419a3.438 3.438 0 0 1 .862-2.267l20.364-23.052c2.582-2.923 7.084-3.121 9.901-.424 14.024 13.431 26.335 19.266 36.822 21.877 3.62.901 6.941 2.723 9.6 5.339l41.517 40.841 13.518-7.568a30.006 30.006 0 0 1 14.657-3.824h1.715M155.869 229.025 7.5 138.311M7.5 339.303l90.32 24.58M125.87 302.89l32.65-77.47c2.09-4.94 7.79-7.26 12.73-5.18l13.54 5.7c4.94 2.09 7.26 7.79 5.18 12.73l-58.7 139.31a9.727 9.727 0 0 1-12.73 5.18L105 377.45c-4.94-2.08-7.26-7.78-5.18-12.72l12.46-29.58M364.536 228.435l139.964-88.05M504.5 339.303 421.728 363.7M357.68 305.65 386.9 375c2.06 4.9 7.7 7.2 12.6 5.13l13.71-5.77c4.9-2.07 7.19-7.71 5.13-12.61l-57.48-136.42c-2.07-4.89-7.71-7.19-12.61-5.13l-13.71 5.78c-4.89 2.06-7.19 7.71-5.13 12.6l14.68 34.82",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#627384",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrust2);
export default __webpack_public_path__ + "static/media/icon-trust2.5192960de35b264e6b4a3d8f41a7396c.svg";
export { ForwardRef as ReactComponent };